import { AiGoodsList } from 'components/goods/ai/AiGoodsList/AiGoodsList'
import { useParams } from 'react-router-dom'

export const SellerAiGoods: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <AiGoodsList sellerId={id as string} />
}
